module.exports = __webpack_public_path__ + "img/80.fd55489e.jpg";